import type { RockStatus } from '@/api/eos/rocks.api';
import type { BadgeProps } from '@/components/ui/Badge';

/**
 * Display metadata for rock statuses — shared by the badge component and
 * pages that need the label (e.g. accessible names on status buttons).
 * Lives outside the component file so Fast Refresh stays happy.
 */
export const ROCK_STATUS_META: Record<RockStatus, { label: string; variant: BadgeProps['variant'] }> = {
  on_track: { label: 'On track', variant: 'success' },
  off_track: { label: 'Off track', variant: 'warning' },
  done: { label: 'Done', variant: 'info' },
};
